/*
 Sets up support for the 'dynamic form' system of the backend, which allows a Django form to be
 submitted for validation and storage via XHR.
 */

define(['jquery'],
    function($) {

        // Dynamic form: submit dynamic forms via AJAX for validation
        $(document).on('submit', 'form.dynamic-form', function (event) {
            event.preventDefault();
            var form = $(event.target);
            var submit_button = form.find('button[type="submit"]');
            var form_data = form.serialize(); // we have to capture this before the form is disabled!

            // remove old alerts and put the form in 'validating' state
            form.find('.alert').slideUp('fast');
            form.find(':input').prop('disabled', true);
            submit_button.button('loading');

            // submit the validation request
            $.post(form.attr('action'), form_data, function (data) {
                var new_form = $(data);
                form.replaceWith(new_form);
                var validation_success = new_form.data('validation-success');
                var auto_display_success = new_form.data('auto-display-success');
                if(validation_success) {
                    if (auto_display_success) {
                        new_form.find('.alert').hide().removeClass('hidden').slideDown();
                    }
                    // trigger custom event
                    new_form.trigger('valid', {'validationSuccess': validation_success});
                }
                new_form.trigger('dynamicFormReinitialize', {'validationSuccess': validation_success});
            });
        });

    }
);
